import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { LoadingController, ModalController, NavController, NavParams, Platform, AlertController } from 'ionic-angular';
import { Redeem } from '../dealdetails/redeem/redeem';
import { DealsDetailsProviderService } from '../../provider/dealsdetailsprovider';
import { ToggleFavouriteService } from '../../provider/togglefavourite';
import { ToggleBlockPartnerService } from '../../provider/toggleblockpartner';
import { ToggleThumbsUpDownService } from '../../provider/togglethumbsdeal';
import { LatLng, LocationService, Spherical } from '@ionic-native/google-maps';
// tslint:disable-next-line:no-duplicate-imports
import { Environment, GoogleMap, GoogleMapOptions, GoogleMaps, GoogleMapsAnimation, GoogleMapsEvent, Marker, MyLocation } from '@ionic-native/google-maps';
import { ConfigurationManager } from '../../provider/ConfigurationManager';
import { Geolocation } from '@ionic-native/geolocation';
import { Network } from '@ionic-native/network';
import * as Constants from '../../provider/Constants';


declare var google;

@Component({
  selector: 'deal-detail-page',
  templateUrl: 'dealdetails.html',

})
export class DealDetailsPage implements OnInit {

  @ViewChild('map') mapElement: ElementRef;

  map: any;
  mapInitialised: boolean = false;
  apiKey = 'AIzaSyBvIYb1zCJpgz8EuCtXg0K4zxhH0afc3yo';


  locations = [];
  sortedImages = [];
  selectedLocationFullAddress = '';
  locationButtonTitle = '';
  blockButtonTitle = '';
  isVisibleLocations = false;
  islocationPresent = false;
  isContactPresent = false;
  selectedLocationPhone = '';
  // visible = false;
  private dealDetail: any;
  isDealFetched = false;
  //map: GoogleMap;
  loading;
  latitude = 0;
  longitude = 0;

  // start to manage summery card icons and dividers
  // below are the file name from images can be moved to constants
  // dollorIcon = 'logo-usd';
  // aaaMemberCardIcon = 'card';
  onlineOfferIcon = 'assets/savingsimg/ic_detail_online_small.png';
  // expiryTimeIcon = 'timer';
  expiryLabelTextColor = 'blue';
  // phoneOfferIcon = 'call';
  // phoneAndOnlineOfferIcon = 'phone-portrait';
  // storeFrontlocationIcon = 'pin';
  // above are the file name from images can be moved to constants

  cardSecondLabelText = '';
  cardThirdLabelText = '';
  cardFirstIcon = 'assets/savingsimg/aaa_dollars.png';
  cardSecondIcon = '';
  cardThirdIcon = '';
  thumbsupgreen = 'assets/savingsimg/ic_detail_vote_up_active.png';
  thumbsupgray = 'assets/savingsimg/ic_detail_vote_up.png';
  thumbsdownred = 'assets/savingsimg/ic_detail_vote_down_active.png';
  thumbsdowngray = 'assets/savingsimg/ic_detail_vote_down.png';

  firstItemVisible = false;
  secondItemVisible = false;
  thirdItemVisible = false;
  firstDividerVisible = false;
  secondDividerVisible = false;
  // end to manage summery card icons and dividers

  isParnterBlocked = false;
  // isImgWidth48:boolean;
  secondIconWidth: number;
  thirdIconWidth: number;
  ThumbStatus = 0;
  likeThumbActive = 0;
  disLikeThumbActive = 0;

  footerButtonTitle = 'Redeem Offer';
  // to change bottom button title, if del type id3 it is book now else redeem offer

  constructor(
    public modalCtrl: ModalController,
    public navCtrl: NavController,
    public navParams: NavParams,
    private dealDetailsService: DealsDetailsProviderService,
    private toggleFavouriteService: ToggleFavouriteService,
    private toggleBlockPartnerService: ToggleBlockPartnerService,
    private toggleThumbsUpDownService: ToggleThumbsUpDownService,
    private manager: ConfigurationManager,
    private platform: Platform,
    private network: Network,
    private alertCtrl: AlertController,
    public loadingCtrl: LoadingController) {
     // this.loadGoogleMaps();

     }



  ngOnInit(): void {
    // this.loadMap(loc);
  }

  

  onRedeemOfferClicked() {
    const profileModal = this.modalCtrl.create(Redeem,
       { dealModel: this.dealDetail,
         environmentConfig: this.navParams.data.EnvironmentConfig ,
         Latitude: this.latitude,
         Longitude: this.longitude
      });
 /*    profileModal.onDidDismiss(data => {
}); */
    profileModal.present();
  }

  // Start Sandeep Code
  onLocationItemClick(locationIndex) {
    this.isVisibleLocations = !this.isVisibleLocations;
    this.updateLocationButtonText();
    this.selectedLocationFullAddress = this.locations[locationIndex].Address + this.locations[locationIndex].City + ', ' + this.locations[locationIndex].State;
    this.selectedLocationPhone = this.locations[locationIndex].LocationPhone;
  }

  shoudOpenLocationList() {
    this.isVisibleLocations = !this.isVisibleLocations;
    this.updateLocationButtonText();
  }

  updateLocationButtonText() {
    // tslint:disable-next-line:prefer-conditional-expression
    if (this.isVisibleLocations) {
      this.locationButtonTitle = 'Hide other locations';
    } else {
      this.locationButtonTitle = 'View other locations (' + this.locations.length + ')';
    }
  }

  showLoadingScreen() {
    // this.loading = this.loadingCtrl.create({

    // });
    // this.loading.present();
  }

  hideLoadingScreen() {
    // if (this.loading != null) {
    //   this.loading.dismiss();
    // }
  }

  onBlockParnterButtonClick() {
    const isNetConnected = this.checkDeviceNetworkConnection();
    if(!isNetConnected) {
      this.showNetworkAlert();
      return;
    }
    this.presentLoading();
    this.showLoadingScreen();
    // this.isParnterBlocked = this.isParnterBlocked;
    const postParams = { 'DealID': this.dealDetail.DealID, 'PartnerID': this.dealDetail.PartnerID, 'BlockedPartnerFlag': this.isParnterBlocked };
    this.toggleBlockPartnerService.toggleBlockPartner(postParams).then(data => {
      this.hideLoadingScreen();
      const json = JSON.parse(data.data);
      if (json.BlockedPartnerFlag === !this.isParnterBlocked) {
        this.isParnterBlocked = !this.isParnterBlocked;
        this.blockButtonTitle = (this.isParnterBlocked) ? 'Un Block offers from ' + this.dealDetail.PartnerName : 'Block offers from ' + this.dealDetail.PartnerName;
      }
    })
      .catch(error => {
        this.hideLoadingScreen();
        // this.isParnterBlocked = !this.isParnterBlocked;//revert the local if fail the operation
      });
  }
  // onLocationPhoneNumberClick() {
  //   this.callNumber.callNumber(this.selectedLocationPhone, true)
  //     .then(res => console.log('Launched dialer!', res))
  //     .catch(err => console.log('Error launching dialer', err));
  // }

  // onRedemptionPhoneNumberClick() {
  //   this.callNumber.callNumber(this.dealDetail.RedemptionPhone, true)
  //     .then(res => console.log('Launched dialer!', res))
  //     .catch(err => console.log('Error launching dialer', err));
  // }

  // onPartnerWebsiteClicked() {
  //   let partnerWebsite: string = this.dealDetail.PartnerWebsite;
  //   if (!partnerWebsite.startsWith('http')) {
  //     partnerWebsite = 'http://' + partnerWebsite;
  //   }
  //   window.open(partnerWebsite, '_blank', 'location=yes');
  // }



  onToggleFavouriteClick() {
    const isNetConnected = this.checkDeviceNetworkConnection();
    if(!isNetConnected) {
      this.showNetworkAlert();
      return;
    }
    this.presentLoading();
    this.showLoadingScreen();
    this.toggleFavouriteService.setFavourite(this.dealDetail).then(data => {
      this.hideLoadingScreen();
      const json = JSON.parse(data.data);
      if (json.FavoritePartnerFlag !== this.dealDetail.FavoritePartnerFlag) {
        this.dealDetail.FavoritePartnerFlag = !this.dealDetail.FavoritePartnerFlag;
      }
    })
      .catch(error => {
        this.hideLoadingScreen();
      });
  }

  onDealLikeButtonClick() {
    const isNetConnected = this.checkDeviceNetworkConnection();
    if(!isNetConnected) {
      this.showNetworkAlert();
      return;
    }
    this.presentLoading();
    this.showLoadingScreen();
    const postParams = { 'DealID': this.dealDetail.DealID, 'PartnerID': this.dealDetail.PartnerID, 'ThumbStatus': (this.likeThumbActive === 1) ? 0 : 1 };
    this.toggleThumbsUpDownService.toggleDealThumbsUpDown(postParams).then(data => {
      this.hideLoadingScreen();
      const json = JSON.parse(data.data);
      if (json.ThumbStatus > -1) {
        this.likeThumbActive = (this.likeThumbActive === 1) ? 0 : 1;
        if (this.likeThumbActive === 1 && this.disLikeThumbActive === 2) {
          this.disLikeThumbActive = 0;
        }
        this.dealDetail.ThumbStatus = this.likeThumbActive;
      }
    })
      .catch(error => {
        this.hideLoadingScreen();
      });
  }

  onDealDisLikeButtonClick() {
    const isNetConnected = this.checkDeviceNetworkConnection();
    if(!isNetConnected) {
      this.showNetworkAlert();
      return;
    }
    this.presentLoading();
    this.showLoadingScreen();
    const postParams = { 'DealID': this.dealDetail.DealID, 'PartnerID': this.dealDetail.PartnerID, 'ThumbStatus': (this.likeThumbActive === 2) ? 0 : 2 };
    this.toggleThumbsUpDownService.toggleDealThumbsUpDown(postParams).then(data => {
      this.hideLoadingScreen();
      const json = JSON.parse(data.data);
      if (json.ThumbStatus > -1) {
        this.disLikeThumbActive = (this.disLikeThumbActive === 2) ? 0 : 2;
        if (this.disLikeThumbActive === 2 && this.likeThumbActive === 1) {
          this.likeThumbActive = 0;
        }
        this.dealDetail.ThumbStatus = this.disLikeThumbActive;
      }
    })
      .catch(error => {
        this.hideLoadingScreen();
      });
  }

  setInitialThumbsStatus() {
    this.likeThumbActive = (this.dealDetail.ThumbStatus === 1) ? 1 : 0;
    if (this.likeThumbActive) {
      this.disLikeThumbActive = (this.dealDetail.ThumbStatus === 2) ? 2 : 0;
    }
  }

  ionViewDidEnter() {
    console.log('Enter view');
    this.getLocation();
  }

  presentLoading() {
    this.loading = this.loadingCtrl.create({
    });
    this.loading.present();
  }

  ionViewWillLeave() {
    console.log('Leave view');
  }

  getLocation() {
    if (null != LocationService) {
      // console.log('locaion service started');
      LocationService.getMyLocation().then((myLocation: MyLocation) => {
        this.latitude = myLocation.latLng.lat;
        this.longitude = myLocation.latLng.lng;
        console.log('Hello dealdetails location lat ' + this.latitude);
        console.log('Hello dealdetails location long ' + this.longitude);
        this.getDealDetailData();
      })
      .catch(error => {
        // console.log('error occured while location '+JSON.stringify(error));
        console.log('locaion error occured DDP');
        this.getDealDetailData();
      });
    } else {
      // console.log('locaion service empty');
      this.getDealDetailData();
    }
  }

  getDealDetailData() {
    const isNetConnected = this.checkDeviceNetworkConnection();
    if(!isNetConnected) {
      this.showNetworkAlert();
      return;
    }
    this.presentLoading();
    // console.log('deal details fetch started with  params '+ JSON.stringify(this.navParams.data));
    this.dealDetailsService.getDealDetailsData(this.navParams.data).then(data => {
      if (this.loading != null) {
        this.loading.dismiss();
      }
      this.isDealFetched = true;
      console.log('data::::json' + JSON.stringify(data.data));
      this.dealDetail = JSON.parse(data.data);

      this.setInitialThumbsStatus();
      this.locations = this.dealDetail.DealLocations;
      // move this code to separate method


      let partnerWebsite: string = this.dealDetail.PartnerWebsite;
      if (partnerWebsite && !partnerWebsite.startsWith('http')) {
        partnerWebsite = 'http://' + partnerWebsite;
        this.dealDetail.PartnerWebsite = partnerWebsite;
      }

      if (this.dealDetail.RedemptionLocation === 'Storefront' && this.locations.length > 0) {
        this.islocationPresent = true;
        //this.loadMap(this.locations[0]);
        this.loadGoogleMaps(this.locations[0]);
        this.arragePartnerLocations();
      } else {
        this.islocationPresent = false;
        if (this.dealDetail.PartnerWebsite || this.dealDetail.RedemptionPhone) {
          this.isContactPresent = true;
        }
      }
      this.blockButtonTitle = 'Block offers from ' + this.dealDetail.PartnerName;
      this.footerButtonTitle = (this.dealDetail.DealTypeID === 3) ? 'Book Now' : 'Redeem Offer';
      this.getSortedDealImages();
      this.arrangeCardLayoutDetails();
    })
      .catch(error => {
        console.log('error occured while fetch deal - status '+error.status + ' message - '+ error.error+ ' headers-' +error.headers);
        if (this.loading != null) {
          this.loading.dismiss();
        }
      });
  }

  getSortedDealImages() {
    const imagesList: any[] = this.dealDetail.DealMediaList;
    imagesList.sort((a, b) => a.DealImageOrder < b.DealImageOrder ? -1 : a.DealImageOrder > b.DealImageOrder ? 1 : 0);
    this.sortedImages = imagesList;
  }

  arrangeCardLayoutDetails() {
    this.addBannerClockImages();
    this.addDesktopLocationImages();
    this.manageDealSummeryImages();
    this.manageDividerImages();
  }

  addBannerClockImages() {
    if ((this.dealDetail.DealTypeID !== 2) && this.dealDetail.DealTypeID !== 3) {
      // this.cardSecondIcon = this.aaaMemberCardIcon;
      //  this.isImgWidth48 = true;
      this.secondIconWidth = 48;
      this.cardSecondIcon = 'assets/savingsimg/ic_aaa_member.png';
      this.cardSecondLabelText = 'AAA\nmember offer';
      this.secondItemVisible = true;
    } else if (this.dealDetail.ExpirationDate) {
      this.secondItemVisible = true;
      this.cardSecondIcon = 'assets/savingsimg/ic_detail_expires_small_disable.png';
      const dealExpiryDate = new Date(this.dealDetail.ExpirationDate);
      const currentDate = new Date();
      const diff = dealExpiryDate.getTime() - currentDate.getTime();
      const diffDays = Math.ceil(diff / (1000 * 3600 * 24));
      if (diffDays < 0) {
        this.cardSecondLabelText = 'Expired';

      } else if (diffDays === 1) {
        this.cardSecondLabelText = diffDays + ' day';
        this.cardSecondIcon = 'assets/savingsimg/ic_detail_expires_small.png';


      } else {
        this.cardSecondLabelText = diffDays + ' days';
        this.expiryLabelTextColor = (diffDays < 5) ? 'danger' : 'blue';
        this.cardSecondIcon = (diffDays < 5) ? 'assets/savingsimg/ic_detail_expires_small.png': 'assets/savingsimg/ic_detail_expires_small_disable.png';
      }
      // this.cardSecondIcon = this.expiryTimeIcon;
      // clock icon shoud place
      // this.isImgWidth48 = false;
      this.secondIconWidth = 32;
    }
  }

  addDesktopLocationImages() {
    this.thirdIconWidth = 32;

    if (this.dealDetail.RedemptionLocation === 'OnLine' || this.dealDetail.RedemptionLocation === 'Online') {
      this.cardThirdIcon = this.onlineOfferIcon;
      this.cardThirdLabelText = 'Online Offer';
      this.thirdItemVisible = true;
    } else if (this.dealDetail.RedemptionLocation === 'Phone') {
      this.cardThirdIcon = 'assets/savingsimg/ic_detail_phone.png'; // this.phoneiconoffer
      this.cardThirdLabelText = 'Phone Offer';
      this.thirdItemVisible = true;
    } else if (this.dealDetail.RedemptionLocation === 'OnLine And Phone' || this.dealDetail.RedemptionLocation === 'Online And Phone') {
      // this.cardThirdIcon = this.phoneAndOnlineOfferIcon;
      this.cardThirdIcon = 'assets/savingsimg/ic_detail_online_phone_small.png';
      this.cardThirdLabelText = 'OnLine And Phone';
      this.thirdItemVisible = true;
    } else if (this.dealDetail.RedemptionLocation === 'Storefront') {
      // this.cardThirdIcon = this.storeFrontlocationIcon;
      this.cardThirdIcon = 'assets/savingsimg/ic_detail_location.png';

      // this.cardThirdLabelText = '-10 hard code';// to calculate the distance and place
      this.cardThirdLabelText = this.getNearestParnterLocation();
      this.thirdItemVisible = true;
    }
  }

  getNearestParnterLocation(): string {
    if (this.dealDetail.DealLocations != null && this.dealDetail.DealLocations[0] != null) {
      return this.getParnterLocationDistance(this.dealDetail.DealLocations[0]);
    }
    return '';
  }
  getParnterLocationDistance(data): string {
    if (data) {
      const lat = data.PartnerLatitude;
      const lng = data.PartnerLongitude;
      const lt = new LatLng(lat, lng);
      const lt2 = new LatLng(this.manager.getLatitude, this.manager.getLongitude);
      const distanceinmiles: number = Spherical.computeDistanceBetween(lt2, lt) / 1609.344;
      if (distanceinmiles < 10) {
        return distanceinmiles.toFixed(1) + ' mi';
      }
      return distanceinmiles.toFixed(0) + ' mi';
    }
    return '';
  }


  manageDealSummeryImages() {
    const isDollorShown = this.dealDetail.AAADollarsFlag;
    // const isClockShown = (this.dealDetail.ExpirationDate) ? true : false;
    // if (isDollorShown && isClockShown) {
    //   this.firstItemVisible = true;
    //   this.secondItemVisible = true;
    // } else if (isDollorShown && isClockShown === false) {
    //   this.firstItemVisible = true;
    //   this.secondItemVisible = false;
    // } else if (isDollorShown === false && isClockShown === false) {
    //   this.firstItemVisible = false;
    //   this.secondItemVisible = false;
    //   // this.thirdItemVisible = true;
    // } else if (!isDollorShown && isClockShown) {
    //   this.secondItemVisible = false;
    //   this.firstItemVisible = false;
    //   // this.thirdItemVisible = true;
    // }


    this.firstItemVisible = isDollorShown;

  }

  manageDividerImages() {
    // tslint:disable-next-line:prefer-conditional-expression
    if (this.firstItemVisible && (this.secondItemVisible || this.thirdItemVisible)) {
      this.firstDividerVisible = true;
    } else {
      this.firstDividerVisible = false;
    }
    // tslint:disable-next-line:prefer-conditional-expression
    if (this.secondItemVisible && this.thirdItemVisible) {
      this.secondDividerVisible = true;
    } else {
      this.secondDividerVisible = false;
    }
  }

  arragePartnerLocations() {
    this.locationButtonTitle = 'View other locations (' + this.locations.length + ')';
    this.selectedLocationFullAddress = this.locations[0].Address + this.locations[0].City + ', ' + this.locations[0].State;
    this.selectedLocationPhone = this.locations[0].LocationPhone;
  }

  




  //==== kiran maps code
  loadGoogleMaps(locations){
    
   // this.addConnectivityListeners();
 
  if(typeof google == "undefined" || typeof google.maps == "undefined"){
 
    console.log("Google maps JavaScript needs to be loaded.");
    this.disableMap();
 
    if(true){
      console.log("online, loading map");
 
      //Load the SDK
      window['mapInit'] = () => {
        this.initMap(locations);
        this.enableMap();
      }
 
      let script = document.createElement("script");
      script.id = "googleMaps";
 
      if(this.apiKey){
        script.src = 'http://maps.google.com/maps/api/js?key=' + this.apiKey + '&callback=mapInit';
      } else {
        script.src = 'http://maps.google.com/maps/api/js?callback=mapInit';      
      }
 
      document.body.appendChild(script); 
 
    }
  }
  else {
 var intertn = true;
    if(intertn){
      console.log("showing map");
      this.initMap(locations);
      this.enableMap();
    }
    else {
      //console.log("disabling map");
      this.disableMap();
    }
 
  }
 
  }
 
  initMap(locations){
    this.mapInitialised = true;
   // Geolocation.getCurrentPosition().then((position) => {
      let latLng = new google.maps.LatLng(locations.PartnerLatitude, locations.PartnerLongitude);
      let mapOptions = { center: latLng,zoom: 15, streetViewControl: false, 
       mapTypeControlOptions: {
         mapTypeIds: ['roadmap']
       }
      }
      this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
      let marker = new google.maps.Marker({position: latLng, map: this.map});
     // let latLng = {lat: 17.230445, lng: 78.5646646};
  // let map = new google.maps.Map(
       //document.getElementById('map'), {zoom: 15, center: latLng});
  // let marker = new google.maps.Marker({position: latLng, map: map});
    //});
  }
  disableMap(){
    console.log("disable map");
  }
  enableMap(){
    console.log("enable map");
  } 
  
  checkDeviceNetworkConnection():boolean {
    if (this.platform.is('cordova')) {
      const isNetworkAvailable = (this.network.type === 'none') ? false : true;
      return isNetworkAvailable;
    }
  }

  showNetworkAlert() {
    let alert = this.alertCtrl.create({
      title: Constants.internetAlertTitle,
      subTitle: Constants.internetAlertMessage,
      buttons: [Constants.alertPositiveButtonTitle]
    });
    alert.present();
  }

  //====

}

